export const CHANGE_LANGUAGE = 'CHANGE_LANGUAGE';
export const Actions={
	CHANGE_LANGUAGE : 'CHANGE_LANGUAGE',
    SET_LANGUAGE:'SET_LANGUAGE'
}

export const updateLanguage=(newLanguage: string)=> 
	(dispatch:any) =>
	 {
		dispatch({
		type:Actions.SET_LANGUAGE,
		payload: newLanguage
		});
	};
    export const changeLanguageAction=(newLanguage: string)=> 
	(dispatch:any) =>
	 {
		dispatch({
		type:Actions.CHANGE_LANGUAGE,
		payload: {
            newLanguage: newLanguage
        }
		});
	};
